export default __webpack_public_path__ + "static/media/cif-ae.f841cbd8.svg";